import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12 max-w-4xl text-center">
        <div className="mb-6">
          <span className="text-cyan-500 text-sm font-semibold tracking-wider uppercase">About Us</span>
        </div>
        
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
          私たちの想い
        </h2>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed text-left">
          <p>
            まごころヘルパーは、逗子・葉山地域に根ざした訪問介護ステーションです。私たちは「作業ではなく、一人ひとりに向き合う介護」を理念に掲げ、ご利用者様の日々の暮らしに寄り添うサービスを提供しています。
          </p>
          <p>
            介護は単なる身体的なサポートではありません。その方の人生、価値観、想いを大切にしながら、尊厳ある生活を支えることが私たちの使命です。一人ひとりのペースに合わせ、心を込めたケアを届けることで、ご利用者様とそのご家族に安心と笑顔をお届けしたいと考えています。
          </p>
          <p>
            地域の皆様から信頼される事業所として、スタッフ一同、日々成長し続けることを大切にしています。
          </p>
        </div>

        <div className="mt-10">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-cyan-600 font-medium hover:text-cyan-700 transition-colors cursor-pointer"
          >
            詳しく見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
